import { useEffect } from 'react'

export const useIframeResize = () => {
  useEffect(() => {
    if (window.self === window.top) return

    const sendHeight = () => {
      const height = document.documentElement.scrollHeight
      window.parent.postMessage({ type: 'iframe-resize', height }, '*')
    }

    const observer = new ResizeObserver(sendHeight)
    observer.observe(document.documentElement)

    sendHeight()

    return () => observer.disconnect()
  }, [])
}
